import { Divider, Spinner } from "@whitespace/whitespace-ui";
import AmplifyError from "components/AmplifyError/AmplifyError";
import MFAOptions from "components/MFAOptions/MFAOptions";
import { useAmplifyREST } from "hooks/useAmplifyREST";
import IUpdateUserMFAOptionRequest from "interfaces/requests/IUpdateUserMFAOptionRequest";
import { useStateMachine } from "little-state-machine";
import { mfaOptions } from "modules/mfaOptions";
import { useEffect, useState } from "react";
import {
  Breadcrumb, Button, Card, Col, Form, Row
} from "react-bootstrap";
import { useForm } from "react-hook-form";

import { Link, useNavigate } from "react-router-dom";

const ManageUserMFAOptions = () => {
  const {
    isSending, errors, sendRequest, resetState, statusCode
  } = useAmplifyREST();
  const navigate = useNavigate();
  const { state } = useStateMachine();
  const [isMFAOptionSelected, setIsMFAOptionSelected] = useState(false);

  const {
    register, handleSubmit, getValues, setValue, watch
  } = useForm({
    mode: "onSubmit"
  });

  const watchFields = watch(["mfaOption"]);

  useEffect(() => {
    if (state.selectedUser && state.selectedUser.mfaOptions) {
      setValue("mfaOption", `${state.selectedUser.mfaOptions.join()}|${state.selectedUser.preferredMfa ?? ""}`);
    }
  }, [state]);

  useEffect(() => {
    const optionSelected = getValues("mfaOption");
    setIsMFAOptionSelected(optionSelected && optionSelected !== `${state.selectedUser!.mfaOptions!.join()}|${state.selectedUser!.preferredMfa ?? ""}`);
  }, [watchFields]);

  const handleSaveClick = () => {
    resetState();
    const selectedMFAOption = mfaOptions().find(mfaOption => mfaOption.id === getValues("mfaOption"));

    if (selectedMFAOption) {
      const payload : IUpdateUserMFAOptionRequest = {
        sms: selectedMFAOption.sms,
        software: selectedMFAOption.software,
        preferredMfa: selectedMFAOption.preferredMFA
      };

      sendRequest(`users/${encodeURIComponent(state.selectedUser!.userId)}/mfa`, "PUT", payload);
    }
  };

  useEffect(() => {
    if (statusCode === 204) {
      navigate("/manageuser");
    }
  }, [statusCode]);
  return (
    <>
      {errors && <AmplifyError errors={errors} />}
      <Card>
        <Card.Header>
          <Row className="w-100">
            <Col xs={8}>
              <h1>
                Manage User - MFA Options
                <Spinner animation="grow" visible={isSending} spinnerText="Loading" variant="info" />
              </h1>
            </Col>
            <Col xs={4} className="d-flex justify-content-end">
              <span className="selected-user-title">{state.selectedUser?.username}</span>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="no-padding">
          <Form noValidate onSubmit={handleSubmit(handleSaveClick)}>
            <Row className="d-flex w-100 align-items-center top-margin-small bottom-margin-small">
              <Col xs={8} className="d-flex">
                <Breadcrumb className="breadcrumb-manage-user left-margin-large no-wrap">
                  <Breadcrumb.Item
                    data-testid="breadcrumb-users"
                    linkAs={Link}
                    linkProps={{ to: "/users" }}
                    onClick={() => navigate("/users")}
                  >
                    Users
                  </Breadcrumb.Item>

                  <Breadcrumb.Item
                    data-testid="breadcrumb-manage-users"
                    linkAs={Link}
                    linkProps={{ to: "/manageuser" }}
                    onClick={() => navigate("/manageuser")}
                  >
                    Manage User
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>MFA Options</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <Col xs={4} className="d-flex justify-content-end user-filter">
                <Button variant="secondary" className="me-2" onClick={() => navigate("/manageuser")}>
                  Back
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={!isMFAOptionSelected || isSending}
                >
                  Save
                </Button>
              </Col>
            </Row>
            <Divider />
            <MFAOptions userHasPhoneConfigured={state.selectedUser!.mobileNumberVerified!} register={register} />
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
export default ManageUserMFAOptions;
